import { gql } from '@apollo/client'
import { RadioCard } from '@farol-ds/react'

import { PlanFrequency, PlanFrequencyLabel } from '../../../../constants'
import { FrequencyOption } from '../frequency-option'
import { FrequencyList_OfferLockCardFragment } from './__generated__/frequency-list.graphql'
import styles from './frequency-list.module.scss'

interface FrequencyListProps {
  defaultFrequency?: PlanFrequency
  metricsRef?: React.RefObject<HTMLButtonElement>
  planOffers: FrequencyList_OfferLockCardFragment[]
  onFrequencyChange: (frequency: string) => void
}

export const FrequencyList = ({
  metricsRef,
  defaultFrequency = PlanFrequency.MONTHLY,
  planOffers = [],
  onFrequencyChange,
}: FrequencyListProps) => {
  return (
    <div className={styles.container}>
      <RadioCard.Group
        defaultValue={defaultFrequency}
        name="frequency-radio-group"
        onValueChange={onFrequencyChange}
      >
        {planOffers.map((planOffer) => {
          const { frequency } = planOffer.offer
          const isYearly = frequency === PlanFrequency.YEARLY

          return (
            <RadioCard
              ref={metricsRef}
              key={`${planOffer.title}-${frequency ?? 'unknown'}`}
              orientation="horizontal"
              value={frequency || PlanFrequency.MONTHLY}
              className={styles.card}
            >
              <FrequencyOption
                offerLockCard={planOffer}
                title={isYearly ? PlanFrequencyLabel.YEARLY : PlanFrequencyLabel.MONTHLY}
              />
            </RadioCard>
          )
        })}
      </RadioCard.Group>
    </div>
  )
}

FrequencyList.fragments = {
  offerLockCard: gql`
    fragment FrequencyList_offerLockCard on OfferLockCard {
      title
      offer {
        frequency
      }
      ...FrequencyOption_offerLockCard
    }
    ${FrequencyOption.fragments.offerLockCard}
  `,
}
